"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "claims",
    path: "/claims",
    component: "Claims"
});
let Claims = class Claims extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    invoiceTypeBadgeClass(...args) {
        const [row] = args;
        const cc = this.$config.invoice.types.colorCodes[row.invoice_type];
        return `bg-${cc.bg} text-${cc.text}`;
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('list_claims');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    async $$load_b_2248226175642056_columns() {
        return [{
                field: "invoice_number",
                name: this.$fn.pgettext("InvoicesView", "Invoice nr"),
                type: "command",
                formatter: [{
                        name: "link",
                        href: "#",
                        className: "command-link",
                    },
                    {
                        name: "cellclass",
                        value: (row) => ({
                            'font-weight-bold': true,
                            'bg-yellow-200': !row.locked,
                            'bg-yellow-500 text-yellow-800': row.is_corrected,
                            'bg-red-300 text-red-800': row.is_reversed,
                        }),
                    },
                ],
            },
            {
                field: "invoice_type",
                name: this.$fn.pgettext("InvoicesView", "Type"),
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "gettext",
                            context: "InvoiceType",
                            conversion: "StartCase",
                            filterInput: true,
                        },
                        {
                            name: "badge",
                            dot: true,
                            pill: true,
                            badgeClass: this.invoiceTypeBadgeClass,
                        },
                    ],
                },
            },
            {
                field: "issuer",
                name: this.$fn.pgettext("Claims", "Issuer"),
                formatter: {
                    name: "chain",
                    formatterContext: "row",
                    formatters: [{
                            name: "getvalue",
                            field: "issuer.name",
                        },
                        {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "issuer.id",
                            },
                        },
                    ],
                },
            },
            {
                field: "client_name",
                name: this.$fn.pgettext("Claims", "Client"),
                formatter: {
                    name: "routeLink",
                    to: "company",
                    navigateOnIconClick: true,
                    params: {
                        id: "client_id",
                    },
                },
            },
            {
                field: "dunning_letters",
                name: this.$fn.pgettext("Claims", "Dunning letters"),
                flags: {
                    preventCellActivate: true,
                },
                type: "command",
                formatter: {
                    name: "dunningLetterBadges",
                },
            },
            {
                field: "uncollectible",
                name: this.$fn.pgettext("Claims", "Uncollectible"),
                formatter: {
                    name: "bool",
                    trueValue: this.$fn.gettext("Yes"),
                },
            },
            {
                field: "days_past_due",
                name: this.$fn.pgettext("Claims", "Days past due"),
                formatter: {
                    name: "overdueHighlight",
                },
            },
            {
                field: "amount",
                name: this.$fn.pgettext("Claims", "Amount"),
                type: "number",
                formatter: "number",
            },
            {
                field: "debt",
                name: this.$fn.pgettext("Claims", "Claim"),
                type: "number",
                formatter: "number",
            },
            {
                field: "paid",
                name: this.$fn.pgettext("Claims", "Paid"),
                type: "number",
                formatter: "number",
            },
            {
                field: "max_payment_date",
                name: this.$fn.pgettext("Claims", "Date of last settlement"),
                type: "date",
            },
            {
                field: "currency",
                name: this.$fn.pgettext("InvoicesView", "Currency"),
            },
            {
                field: "invoice_date",
                name: this.$fn.pgettext("InvoicesView", "Invoice date"),
            },
            {
                field: "fulfillment_date",
                name: this.$fn.pgettext("InvoicesView", "Fulfillment date"),
            },
            {
                field: "due_date",
                name: this.$fn.pgettext("InvoicesView", "Due date"),
            },
            {
                field: "payment_method",
                name: this.$fn.pgettext("InvoicesView", "Payment method"),
                formatter: {
                    name: "gettext",
                    context: "PaymentMethod",
                    conversion: "Sentence",
                    filterInput: true,
                },
            },
        ];
    }
    dataMembers = ['selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Claims", "Claims"),
                icon: this.$config.claim.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3066_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_3068_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_showModal_3070_getActionArgs($event) {
        return {
            name: "DunningLetter",
            props: {
                id: $event.data.element.dataset.value,
            },
        };
    }
    async evh_2248226175642056_command_3069_getWhen($event) {
        return $event.data.column.id === 'dunning_letters';
    }
    async act_2248226175642056_showModal_3072_getActionArgs($event) {
        return {
            name: "Invoice",
            props: {
                oid: $event.data.data.id,
            },
        };
    }
    async evh_2248226175642056_command_3071_getWhen($event) {
        return $event.data.column.id === 'invoice_number';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_showModal_3074_getActionArgs($event) {
        return {
            name: "CreateDunningLetter",
            props: {
                items: this.selectedItems,
            },
        };
    }
    async evh_6466705138206980_click(event, scope) {
        return await this.actions.evh_6466705138206980_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3066 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3066_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3065 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3066,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3065],
        });
        const act_2248226175642056_setData_3068 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_3068_getActionArgs,
            displayName: "setSelectedItems",
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_3067 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_3068,
            event: "selectedRowsChanged",
            displayName: "setSelectedItems",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_3067],
        });
        const act_2248226175642056_showModal_3070 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_3070_getActionArgs,
            displayName: "showDunningLetter",
            events: [],
        });
        const evh_2248226175642056_command_3069 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_3070,
            event: "command",
            when: this.evh_2248226175642056_command_3069_getWhen,
            displayName: "showDunningLetter",
        });
        const act_2248226175642056_showModal_3072 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_3072_getActionArgs,
            displayName: "showInvoiceModal",
            events: [],
        });
        const evh_2248226175642056_command_3071 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_3072,
            event: "command",
            when: this.evh_2248226175642056_command_3071_getWhen,
            displayName: "showInvoiceModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_3069, evh_2248226175642056_command_3071],
        });
        const act_6466705138206980_showModal_3074 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6466705138206980_showModal_3074_getActionArgs,
            displayName: "showCreateDunningLetter",
            events: [],
        });
        const evh_6466705138206980_click_3073 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_showModal_3074,
            event: "click",
            displayName: "showCreateDunningLetter",
        });
        const evh_6466705138206980_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_click_3073],
        });
        return {
            act_7315092382398562_closeModal_3066,
            evh_7315092382398562_close_3065,
            evh_7315092382398562_close,
            act_2248226175642056_setData_3068,
            evh_2248226175642056_selectedRowsChanged_3067,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_showModal_3070,
            evh_2248226175642056_command_3069,
            act_2248226175642056_showModal_3072,
            evh_2248226175642056_command_3071,
            evh_2248226175642056_command,
            act_6466705138206980_showModal_3074,
            evh_6466705138206980_click_3073,
            evh_6466705138206980_click,
            setSelectedItems: act_2248226175642056_setData_3068,
            showDunningLetter: act_2248226175642056_showModal_3070,
            showInvoiceModal: act_2248226175642056_showModal_3072,
            showCreateDunningLetter: act_6466705138206980_showModal_3074,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Claims.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Claims.prototype, "onSize", null);
Claims = __decorate([
    (0, vue_property_decorator_1.Component)()
], Claims);
exports.default = Claims;
vue_property_decorator_1.Vue.component("Claims", Claims);
